import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import type { ApiMentionedWave } from "@/generated/models/ApiMentionedWave";
export default function DropListItemContentWaveMention(t0) {
  const $ = _c(3);
  const {
    wave
  } = t0;
  const t1 = `/waves?wave=${wave.wave_id}`;
  let t2;
  if ($[0] !== t1 || $[1] !== wave.wave_name_in_content) {
    t2 = <Link onClick={_temp} href={t1} className="tw-align-middle tw-font-medium tw-text-primary-400 tw-no-underline tw-transition tw-duration-300 tw-ease-out desktop-hover:hover:tw-text-primary-300 desktop-hover:hover:tw-underline">#{wave.wave_name_in_content}</Link>;
    $[0] = t1;
    $[1] = wave.wave_name_in_content;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
function _temp(e) {
  return e.stopPropagation();
}